export const SUPPORTED_LOCALES = [
  { key: '', label: 'Original', abbr: '' },
  { key: 'de', label: 'Deutsch', abbr: 'DE', enAbbr: 'German' },
  { key: 'en', label: 'English', abbr: 'EN' },
  {
    key: 'fr',
    label: 'Français',
    abbr: 'FR',
    enAbbr: 'French',
    numberSuffix: ['_one', '_many', '_other'],
  },
  { key: 'nl', label: 'Nederlands', abbr: 'NL', enAbbr: 'Dutch' },
  {
    key: 'ru',
    label: 'Русский',
    abbr: 'RU',
    enAbbr: 'Russian',
    numberSuffix: ['_one', '_few', '_many', '_other'],
  },
  {
    key: 'uk',
    label: 'українська',
    abbr: 'UK',
    enAbbr: 'Ukrainian',
    numberSuffix: ['_one', '_few', '_many', '_other'],
  },
  { key: 'zh-cn', label: '中文简体', abbr: 'ZH' },
  { key: 'zh-tw', label: '中文繁體', abbr: 'ZH' },
  { key: 'vi', abbr: 'VI', label: 'Tiếng Việt', enAbbr: 'Vietnamese' },
  { key: 'ja', abbr: 'JA', label: '日本語', enAbbr: 'Japanese' },
  { key: 'tr', abbr: 'TR', label: 'Türkçe', enAbbr: 'turkish' },
  { key: 'id', abbr: 'ID', label: 'Indonesia', enAbbr: 'Indonesian' },
  { key: 'ko', abbr: 'KO', label: '한국인', enAbbr: 'Korean' },
  {
    key: 'pl',
    abbr: 'PL',
    label: 'Polski',
    enAbbr: 'Polish',
    numberSuffix: ['_one', '_few', '_many', '_other'],
  },
  {
    key: 'es',
    abbr: 'ES',
    label: 'Español',
    enAbbr: 'Spanish',
    numberSuffix: ['_one', '_many', '_other'],
  },
  {
    key: 'it',
    abbr: 'IT',
    label: 'Italiano',
    enAbbr: 'Italian',
    numberSuffix: ['_one', '_many', '_other'],
  },
  {
    key: 'pt',
    abbr: 'PT',
    label: 'Português',
    enAbbr: 'Portuguese',
    numberSuffix: ['_one', '_many', '_other'],
  },
  { key: 'bg', abbr: 'BG', label: 'български', enAbbr: 'Bulgarian' },
] as const;

export type SUPPORTED_LOCALE_TYPE = (typeof SUPPORTED_LOCALES)[number]['key'];
